<template>
    <BreadCrumb PageTitle="Ajouter un type un type d'Acteur" />
    <AddModalTypeActeur />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddModalTypeActeur from "@/components/TypeActeur/AddModalTypeActeur.vue";


export default defineComponent({
    name: "AddTypeActeurPage",
    components: {
        BreadCrumb,
        AddModalTypeActeur,
    },
});
</script>